<template lang="pug">
.res-success
  .success
    .check
      icon-check(ref="check")
    .copy {{$t('reservation.success')}}
  .confirm
  .tips
    p 感谢你预约支付宝空间站！
    p 空间站新上线“我的足迹”及“惊喜盲盒”，到场即可参与体验～
    p 签到后，首页进入”我的足迹“，一起探索你的绿色之旅吧！
    //confirm-card
    //- img(src="~assets/res-suc-notify.png")

</template>
<script>
import ConfirmCard from '@/components/res/ConfirmCard'
import IconCheck from '@/components/wedgits/IconCheck'
import { mapMutations, mapActions } from 'vuex'
import CountdownBtn from '@/components/wedgits/CountdownBtn'
export default {
  name: 'ResSuccess',
  components: { CountdownBtn, IconCheck, ConfirmCard },
  props: {},
  data() {
    return {}
  },
  created() {
    //console.log('res ConFirm!!!!!!!!', this.$route.query)
    this.setPending(true)
    this.ResConfirm(this.$route.query.resId).then((res) => {
      console.log('res success', res)
      this.setPending(false)
      this.animeIn()
    })
    //this.animeIn()
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setPending']),
    ...mapActions('app', ['ResConfirm']),
    animeIn() {
      this.$refs.check.animeIn()
    },
  },
  mounted() {
    //this.animeIn()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-success
  width: 100%
  height: 100%
  .success
    width: 100%
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    .check
      width: pxToRem(108)
      height: pxToRem(108)
    .copy
      font-size: pxToRem(36)
      margin-top: pxToRem(40)
      color: black
  .confirm
    margin-top: pxToRem(50)
    width: 100%
    display: flex
    justify-content: center
    align-items: center
    img
      width: 100%
      object-fit: contain
    //margin-left: -2.5%
    //width: 105%
    //height: pxToRem(810)
    //margin-top: pxToRem(200)
    //margin-left: pxToRem(-30)
    //width: pxToRem(750)
    //height: pxToRem(602)
  .tips
    margin-top: pxToRem(100)
    padding: 0 pxToRem(40)
    p
      font-size: pxToRem(32) 
      line-height: pxToRem(42) 
      margin-bottom: pxToRem(16)
</style>
